// extracted by css-extract-rspack-plugin
export default {"optionRow":"cqyNIK","spendingName":"GfTl12","badges":"YAwtEN","iconBadge":"L_5qnB"};